import React from "react";
import {
  Box,
  Button,
  Chip,
} from "@mui/material";

import Header from "../../components/Header";

import AuditAreaAccordion from "../../components/AuditAreaAccordion";
import AuditProgressSummary from "../../components/AuditProgressSummary";

import useRunOperationalAudit from "../../hooks/useRunOperationalAudit";

import { formatOperationalAuditEnum } from "../../utils/operationalAuditFormatting";

const RunOperationalAudit = () => {
  const {
    audit,
    groupedQuestions,
    responses,
    progress,

    loading,
    submitting,
    auditLocked,

    updateResponse,
    handleProcessStatusChange,
    handleDocumentationStatusChange,

    handleSubmit,
    handleCancel,
  } = useRunOperationalAudit();

  if (loading) {
    return (
      <Box>
        <Header
          title="RUN OPERATIONAL AUDIT"
          subtitle="Loading operational audit..."
        />
      </Box>
    );
  }

  if (!audit) {
    return (
      <Box>
        <Header
          title="RUN OPERATIONAL AUDIT"
          subtitle="The operational audit could not be loaded"
        />
      </Box>
    );
  }

  return (
    <Box>
      <Header
        title="RUN OPERATIONAL AUDIT"
        subtitle={`${audit.name} — ${formatOperationalAuditEnum(
          audit.industry,
        )}`}
      />

      {auditLocked && (
        <Box mb={2}>
          <Chip
            label="This audit has already been completed and is locked"
            color="success"
            variant="filled"
          />
        </Box>
      )}

      <AuditProgressSummary
        progress={progress}
        submitting={submitting}
        auditLocked={auditLocked}
        onSubmit={handleSubmit}
      />

      {Object.entries(groupedQuestions).map(
        ([area, areaQuestions]) => (
          <AuditAreaAccordion
            key={area}
            area={area}
            questions={areaQuestions}
            responses={responses}
            auditLocked={auditLocked}
            onUpdateResponse={updateResponse}
            onProcessStatusChange={
              handleProcessStatusChange
            }
            onDocumentationStatusChange={
              handleDocumentationStatusChange
            }
          />
        ),
      )}

      <Box
        display="flex"
        justifyContent="flex-end"
        mt={3}
        gap={2}
      >
        <Button
          variant="outlined"
          color="secondary"
          disabled={submitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="secondary"
          disabled={submitting || auditLocked}
          onClick={handleSubmit}
        >
          {submitting
            ? "Completing..."
            : "Complete Audit"}
        </Button>
      </Box>
    </Box>
  );
};

export default RunOperationalAudit;